import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../contexts/AuthContext";
import Loader from "./Loader";




const AppraisalForm = () => {
    
    const { authTokens, user } = useContext(AuthContext);
    console.log(user);
    const [checkingEligibility, setCheckingEligibility] = useState(
    user?.user_role === "EMPLOYEE"
);
    const [isEligible, setIsEligible] = useState(false);
    const [eligibilityLoaded, setEligibilityLoaded] = useState(false);
    const role = user?.user_role;
    console.log(
    "Role:",
    role,
    "Eligible:",
    isEligible,
    "Loaded:",
    eligibilityLoaded
);
    
    const [eligibilityMessage, setEligibilityMessage] = useState("");

   useEffect(() => {

    if (!user?.user_role) {
        return;
    }

    if (user.user_role !== "EMPLOYEE") {
        setEligibilityLoaded(true);
        setCheckingEligibility(false);
        return;
    }

    if (authTokens?.access) {
        fetchEligibility();
    }

}, [user?.user_role, authTokens?.access]);

const fetchEligibility = async () => {
    console.log("CALLING ELIGIBILITY API");

    setCheckingEligibility(true);

    try {

        const response = await fetch(
            "https://ess-api-django-a6fc2c26f42e.herokuapp.com/api/appraisal_eligibility/",
            {
                headers: {
                    Authorization:
                        "Bearer " + authTokens.access,
                },
            }
        );

        const data = await response.json();
        console.log("ELIGIBILITY RESPONSE", data);
        if (!response.ok) {

    setIsEligible(false);

    setEligibilityMessage(
        data.detail ||
        data.error ||
        "Unable to verify eligibility"
    );

    return;
}

setIsEligible(data.eligible || false);

setEligibilityMessage(
    data.message || ""
);


    } catch (error) {
        console.log(error);
        setIsEligible(false);
    } finally {
        setEligibilityLoaded(true);
        setCheckingEligibility(false);
    }
};

    const email = user?.email?.toLowerCase();
    const isJerson = email === "jerson.antony@prowesstics.com";
    
    const isNormalManager = role === "MANAGER" &&
    !isJerson
    
    
    



const canUpload =
    (
        role === "EMPLOYEE"
            ? (eligibilityLoaded && isEligible)
            : true
    ) &&
    (
        role === "TRAINEE" ||
        role === "EMPLOYEE" ||
        isNormalManager
    );

    const canViewFiles =
    isNormalManager ||
    isJerson;

    const [isLoading, setIsLoading] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);

    const [uploadedFiles, setUploadedFiles] = useState([]);

    const [selectedFiles, setSelectedFiles] = useState([]);

    

    useEffect(() => {
    if (canViewFiles) {
        fetchUploadedFiles();
    }
}, [canViewFiles]);

   const fetchUploadedFiles = async () => {
    try {

        const response = await fetch(
            "https://ess-api-django-a6fc2c26f42e.herokuapp.com/api/appraisal_files",
            {
                headers: {
                    Authorization:
                        "Bearer " + authTokens.access,
                },
            }
        );

        const data =
            await response.json();

        setUploadedFiles(
    Array.isArray(data)
        ? data
        : data.files || []
);

    } catch (error) {
        console.log(error);
    }
};

    const downloadTemplate = async () => {
    try {
        setIsLoading(true);

        const response = await fetch(
            "https://ess-api-django-a6fc2c26f42e.herokuapp.com/api/appraisal_form",
            {
                method: "GET",
                headers: {
                    Authorization:
                        "Bearer " + authTokens.access,
                },
            }
        );

        if (!response.ok) {
            const err = await response.json();
            throw new Error(
                err.error || "Download failed"
            );
        }

        const blob = await response.blob();

        const url =
            window.URL.createObjectURL(blob);

        const a =
            document.createElement("a");

        a.href = url;

        a.download =
            "Appraisal-2025-2026.xlsx";

        document.body.appendChild(a);

        a.click();

        a.remove();

        window.URL.revokeObjectURL(url);

    } catch (error) {
        console.log(error);
        alert(error.message);
    } finally {
        setIsLoading(false);
    }
};

    const uploadFile = async () => {
    if (!selectedFile) {
        alert("Please select a file");
        return;
    }

    try {
        setIsLoading(true);

        const formData = new FormData();

        formData.append(
            "file",
            selectedFile
        );

        const response = await fetch(
            "https://ess-api-django-a6fc2c26f42e.herokuapp.com/api/appraisal_upload",
            {
                method: "POST",
                headers: {
                    Authorization:
                        "Bearer " + authTokens.access,
                },
                body: formData,
            }
        );

        const data =
            await response.json();

        if (!response.ok) {
            throw new Error(
                data.error || "Upload failed"
            );
        }

        alert("Uploaded successfully");
        setSelectedFile(null);

// Reset file input
const fileInput =
    document.getElementById("appraisal-file");

if (fileInput) {
    fileInput.value = "";
}
if (canViewFiles) {
    await fetchUploadedFiles();
}

    } catch (error) {
        console.log(error);
        alert(error.message);
    } finally {
        setIsLoading(false);
    }
};

    const handleSelectFile = (id) => {
        if (selectedFiles.includes(id)) {
            setSelectedFiles(
                selectedFiles.filter(
                    (item) => item !== id
                )
            );
        } else {
            setSelectedFiles([
                ...selectedFiles,
                id,
            ]);
        }
    };

    const downloadAllFiles = async () => {
    try {

        const response = await fetch(
            "https://ess-api-django-a6fc2c26f42e.herokuapp.com/api/appraisal_download_all",
            {
                headers: {
                    Authorization:
                        "Bearer " + authTokens.access,
                },
            }
        );

        const blob = await response.blob();

        const url =
            window.URL.createObjectURL(blob);

        const a =
            document.createElement("a");

        a.href = url;

        a.download =
            "All_Appraisals.zip";

        document.body.appendChild(a);

        a.click();

        a.remove();

        window.URL.revokeObjectURL(url);

    } catch (error) {
        console.log(error);
    }
};

    const downloadSelectedFiles = async () => {

    if (selectedFiles.length === 0) {
        alert("Please select files");
        return;
    }

    try {

        const response = await fetch(
            "https://ess-api-django-a6fc2c26f42e.herokuapp.com/api/appraisal_download_selected",
            {
                method: "POST",

                headers: {
                    Authorization:
                        "Bearer " + authTokens.access,
                    "Content-Type":
                        "application/json",
                },

                body: JSON.stringify({
                    ids: selectedFiles,
                }),
            }
        );

        const blob =
            await response.blob();

        const url =
            window.URL.createObjectURL(blob);

        const a =
            document.createElement("a");

        a.href = url;

        a.download =
            "Selected_Appraisals.zip";

        document.body.appendChild(a);

        a.click();

        a.remove();

        window.URL.revokeObjectURL(url);

    } catch (error) {
        console.log(error);
    }
};

    if (isLoading) {
        return (
            <div className="w-full h-[70vh] flex justify-center items-center">
                <Loader />
            </div>
        );
    }

//     if (
//     role === "EMPLOYEE" &&
//     checkingEligibility
// ) {
//     return (
//         <div className="w-full h-[70vh] flex justify-center items-center">
//             <Loader />
//         </div>
//     );
// }

console.log({
    checkingEligibility,
    eligibilityLoaded,
    isEligible,
    eligibilityMessage,
    role
});

if (
    user?.user_role === "EMPLOYEE" &&
    !eligibilityLoaded
) {
    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 999999999,
                background: "rgba(0,0,0,0.4)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Loader />
        </div>
    );
}

if (!user?.user_role) {
    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 999999999,
                background: "rgba(0,0,0,0.4)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Loader />
        </div>
    );
}

    // Replace your return(...) with this structure, keeping all existing state/logic above

return (
    <div className="w-auto my-6 mx-6 py-4 px-2 text-secondary
    dark:text-white">

        {/* Page header */}
        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-200 dark:border-gray-700">
            <div className="w-10 h-10 rounded-lg bg-accent flex items-center justify-center">
                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
            </div>
            <div>
                <h2 className="text-lg font-semibold text-bright">Appraisal management</h2>
                <p className="text-sm text-secondary">FY 2025–2026 performance review cycle</p>
            </div>
        </div>

        {/* Ineligibility banner */}
        {!isEligible && role === "EMPLOYEE" && eligibilityMessage && (
            <div className="flex items-start gap-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-700 text-yellow-800 dark:text-yellow-300 p-4 rounded-lg mb-4 text-sm">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                </svg>
                <span>{eligibilityMessage}</span>
            </div>
        )}

        {/* Upload section */}
        {canUpload && (
            <div className="bg-primary box-shadow rounded-xl p-6">
                <h3 className="text-base font-medium text-secondary dark:text-white flex items-center gap-2 mb-4">
                    <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Appraisal form
                </h3>

                {/* Steps */}
                <div className="space-y-0 divide-y divide-gray-100 dark:divide-gray-700">
                    {/* Step 1 */}
                    <div className="flex gap-3 py-4">
                        <div className="w-6 h-6 rounded-full bg-accent text-blue-600 text-xs font-medium flex items-center justify-center flex-shrink-0 mt-0.5">1</div>
                        <div>
                            <p className="text-sm font-medium text-secondary dark:text-white mb-1">Download the template</p>
                            <p className="text-xs text-secondary mb-3">Get the official Excel appraisal form for FY 2025–2026.</p>
                            <button
                                onClick={downloadTemplate}
                                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-lg transition-colors"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                </svg>
                                Download template
                            </button>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="flex gap-3 py-4">
                        <div className="w-6 h-6 rounded-full bg-accent text-blue-600 text-xs font-medium flex items-center justify-center flex-shrink-0 mt-0.5">2</div>
                        <div>
                            <p className="text-sm font-medium text-secondary dark:text-white mb-1">Fill in your details</p>
                            <p className="text-xs text-secondary">Complete all sections of the downloaded template and save it.</p>
                        </div>
                    </div>

                    {/* Step 3 - Upload */}
                    <div className="flex gap-3 py-4">
                        <div className="w-6 h-6 rounded-full bg-accent text-blue-600 text-xs font-medium flex items-center justify-center flex-shrink-0 mt-0.5">3</div>
                        <div className="flex-1">
                            <p className="text-sm font-medium text-secondary dark:text-white mb-1">Upload the filled form</p>
                            <p className="text-xs text-secondary mb-3">Upload your completed .xlsx or .xls file below.</p>

                            {/* Drop zone */}
                            <label
                                htmlFor="appraisal-file"
                                className="flex flex-col items-center justify-center w-full border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-8 cursor-pointer bg-primary hover:border-blue-400 hover:bg-blue-50/50 dark:hover:bg-blue-900/10 transition-colors"
                            >
                                <svg className="w-7 h-7 text-secondary mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                                <p className="text-sm text-bright mb-1">Drag & drop your file here, or <span className="text-blue-600 font-medium">browse</span></p>
                                <p className="text-xs text-secondary">Accepted: .xlsx, .xls</p>
                                <input id="appraisal-file" type="file" accept=".xlsx,.xls" className="hidden"
                                    onChange={(e) => setSelectedFile(e.target.files?.[0] || null)} />
                            </label>

                            {/* File pill */}
                            {selectedFile && (
                                <div className="mt-3 flex items-center gap-3">
                                    <div className="inline-flex items-center gap-2 bg-accent text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700 rounded-lg px-3 py-1.5 text-sm">
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        {selectedFile.name}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => { setSelectedFile(null); const fi = document.getElementById("appraisal-file"); if (fi) fi.value = ""; }}
                                        className="text-red-500 hover:text-red-600 text-sm flex items-center gap-1"
                                    >
                                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                        Remove
                                    </button>
                                </div>
                            )}

                            <button
                                onClick={uploadFile}
                                disabled={!selectedFile}
                                className={`inline-flex items-center gap-2 mt-3 text-sm px-4 py-2 rounded-lg transition-colors ${
                                    selectedFile
                                        ? "bg-green-600 hover:bg-green-700 text-white cursor-pointer"
                                        : "bg-gray-100 dark:bg-gray-700 text-secondary cursor-not-allowed"
                                }`}
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                </svg>
                                Submit appraisal
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Manager files table */}
        {canViewFiles && (
            <div className="bg-accent box-shadow rounded-xl p-6">
                <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
                    <h3 className="text-base font-medium text-secondary dark:text-white flex items-center gap-2">
                        <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                        </svg>
                        Submitted appraisals
                        <span className="text-xs font-medium bg-gray-100 dark:bg-gray-700 text-accent px-2 py-0.5 rounded-full">
                            {uploadedFiles.length}
                        </span>
                    </h3>
                    <div className="flex gap-2">
                        <button onClick={downloadSelectedFiles}
                            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-lg transition-colors">
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            Download selected
                        </button>
                        <button onClick={downloadAllFiles}
                            className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-700 text-white transition-colors">
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                            </svg>
                            Download all
                        </button>
                    </div>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b border-gray-100 dark:border-gray-700">
                                <th className="w-8 pb-2 text-left"></th>
                                <th className="pb-2 text-left text-xs font-medium text-secondary uppercase tracking-wide">Employee</th>
                                <th className="pb-2 text-left text-xs font-medium text-secondary uppercase tracking-wide">File name</th>
                                <th className="pb-2 text-left text-xs font-medium text-secondary uppercase tracking-wide">Submitted on</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(uploadedFiles || []).map((file) => {
                                const initials = file.employee_name?.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
                                return (
                                    <tr key={file.id} className="border-b border-gray-50 dark:border-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/30">
                                        <td className="py-3">
                                            <input type="checkbox"
                                                checked={selectedFiles.includes(file.id)}
                                                onChange={() => handleSelectFile(file.id)}
                                                className="accent-blue-600 w-4 h-4" />
                                        </td>
                                        <td className="py-3">
                                            <div className="flex items-center gap-2">
                                                <div className="w-7 h-7 rounded-full bg-accent text-blue-600 dark:text-blue-400 text-xs font-medium flex items-center justify-center flex-shrink-0">
                                                    {initials}
                                                </div>
                                                {file.employee_name}
                                            </div>
                                        </td>
                                        <td className="py-3 text-secondary dark:text-secondary">{file.file_name}</td>
                                        <td className="py-3 text-secondary dark:text-secondary">{file.uploaded_at}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        )}
    </div>
);
};

export default AppraisalForm;